export const publicSite = {
  brand: {
    name: "Treasure Tome",
    tagline: "Turn memory work into an adventure.",
    description: "A cheerful practice companion that helps homeschoolers memorize poems, speeches, scripture, and more—one small win at a time.",
    logoUrl: "https://customer-assets.emergentagent.com/job_seven-seas-poetry/artifacts/t3a36crn_D3641919-A753-4C47-B93E-EF4B277DB791.png",
  },
  routes: {
    getStarted: "/welcome",
    signIn: "/welcome?view=login",
    joinFamily: "/join",
    privacy: "/privacy",
    terms: "/terms",
  },
  contact: {
    supportEmail: "support@treasuretome.com",
  },
  trial: {
    days: 7,
    cardRequired: false,
  },
  plans: [
    {
      id: "solo",
      name: "Solo Adventurer",
      audience: "For one learner",
      price: "$14.99",
      regularPrice: null,
      period: "for 12 months",
      description: "A complete personal adventure with practice tools, progress, rewards, and a customizable character.",
      features: ["1 learner profile", "Full practice experience", "Progress and streaks", "Treasure and character rewards"],
      featured: false,
    },
    {
      id: "family",
      name: "Family Crew",
      audience: "For a parent and up to 5 children",
      price: "$19.99",
      regularPrice: "$24.99",
      period: "for 12 months",
      badge: "Launch price · first 100 families",
      description: "One parent dashboard and separate adventures for the whole crew.",
      features: ["1 parent + up to 5 kids", "Separate child progress", "Parent dashboard", "Private family joining code"],
      featured: true,
    },
  ],
  features: [
    { icon: "📖", title: "Practice in small steps", text: "Work through a piece at a comfortable pace with tools designed to make repetition feel manageable." },
    { icon: "🗺️", title: "See the journey", text: "Streaks, progress, and a Seven Seas map help learners see how far they have come." },
    { icon: "🪙", title: "Earn meaningful rewards", text: "Practice earns treasure that unlocks fun character choices without ads or in-app purchases." },
    { icon: "👨‍👩‍👧‍👦", title: "Built for homeschool families", text: "Family accounts give parents a simple view of each child's activity while every learner gets their own profile." },
  ],
  trustPoints: [
    "No credit card for the trial",
    "No automatic renewal",
    "No ads or in-app purchases",
    "One simple annual payment",
  ],
  faqs: [
    { question: "What can my child memorize?", answer: "Treasure Tome is designed for memory work such as poems, speeches, scripture, and other passages available in the app or added through supported tools." },
    { question: "Will I be charged after the free trial?", answer: "No. The 7-day trial does not require a card. You choose whether to purchase 12 months of access afterward." },
    { question: "Does the annual plan renew automatically?", answer: "No. Treasure Tome does not automatically renew your purchase. You will not have to remember to cancel a subscription." },
    { question: "What is included in a family account?", answer: "A family account includes one parent account, a parent dashboard, and separate profiles for up to five children." },
    { question: "Can children join on another device?", answer: "Yes. A child can join the family using the private family code provided by the parent." },
  ],
};

